module.exports = __webpack_public_path__ + "img/sun2.53d851ca.svg";